const STAFF_LOGOUT_INTENT_KEY = 'oms-staff-logout-intent'
const STAFF_LOGOUT_INTENT_TTL_MS = 30_000

/** Mark an intentional staff sign-out so login does not resume the previous deep link. */
export function markStaffLogoutIntent(): void {
  try {
    sessionStorage.setItem(STAFF_LOGOUT_INTENT_KEY, String(Date.now()))
  } catch {
    /* ignore quota / private mode */
  }
}

function readStaffLogoutIntentAgeMs(): number | null {
  try {
    const raw = sessionStorage.getItem(STAFF_LOGOUT_INTENT_KEY)
    if (!raw) return null
    const ts = Number(raw)
    if (!Number.isFinite(ts)) return null
    const age = Date.now() - ts
    if (age < 0 || age > STAFF_LOGOUT_INTENT_TTL_MS) {
      sessionStorage.removeItem(STAFF_LOGOUT_INTENT_KEY)
      return null
    }
    return age
  } catch {
    return null
  }
}

/** True when staff just signed out intentionally (clears the flag). */
export function consumeStaffLogoutIntent(): boolean {
  const age = readStaffLogoutIntentAgeMs()
  if (age == null) return false
  try {
    sessionStorage.removeItem(STAFF_LOGOUT_INTENT_KEY)
  } catch {
    /* ignore */
  }
  return true
}

/** Peek without clearing — used when redirecting unauthenticated users to login. */
export function hasRecentStaffLogoutIntent(): boolean {
  return readStaffLogoutIntentAgeMs() != null
}

/**
 * Resolve where staff should land after login.
 * Avoid resuming entity detail pages from another shop or prior session.
 */
export function resolveStaffPostLoginPath(fromPathname?: string | null): string {
  if (consumeStaffLogoutIntent()) {
    return '/dashboard'
  }

  const path = (fromPathname || '').trim()
  if (!path || !path.startsWith('/dashboard')) {
    return '/dashboard'
  }

  // /dashboard/orders/123 or /dashboard/orders/123/edit → list section
  const entityDetail = path.match(/^(\/dashboard\/[^/]+)\/\d+/)
  if (entityDetail) {
    return entityDetail[1]
  }

  return path
}
